<template>
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div v-if="id == 0 || id == 1">
        <blue-title class="style">营业执照</blue-title>
        <License
          :subjectData="subjectData"
          :count.sync="count"
          @changeType="changeType"
          @handleMediaId="handleMediaId"
          @confirm="handleValidityLicense"
        ></License>
      </div>
      <div v-if="id == 2 || id == 3">
        <blue-title class="style">登记证书</blue-title>
        <Certificate
          :count.sync="count"
          :subjectData="subjectData"
          @changeType="changeType"
          @confirm="handleValidityCertificate"
        ></Certificate>
      </div>
      <div v-if="type">
        <blue-title class="style">组织机构代码证</blue-title>
        <Institutions
          :count.sync="count"
          :subjectData="subjectData"
          @confirm="handleValidityInstitutions"
        ></Institutions>
      </div>
      <div v-if="id == 2">
        <blue-title class="style">身份验证</blue-title>
        <IdentityVerify
          :count.sync="count"
          :subjectData="subjectData"
          @confirm="handleValidityIdentityVerify"
        ></IdentityVerify>
      </div>
      <div v-if="id == 0">
        <blue-title class="style">经营者证件</blue-title>
        <IdCard
          :count.sync="count"
          :subjectData="subjectData"
          @changeOwner="changeOwner"
          @handleMediaIdCard1="handleMediaIdCard1"
          @handleMediaIdCard2="handleMediaIdCard2"
          @confirm="handleValidityIdCard"
        ></IdCard>
      </div>
      <div v-if="id != 0">
        <blue-title class="style">法定代表人证件</blue-title>
        <IdCard
          :count.sync="count"
          :subjectData="subjectData"
          @changeOwner="changeOwner"
          @handleMediaIdCard1="handleMediaIdCard1"
          @handleMediaIdCard2="handleMediaIdCard2"
          @confirm="handleValidityIdCard"
        ></IdCard>
      </div>
      <div v-if="owner && id != 2">
        <blue-title class="style">最终受益人信息</blue-title>
        <Beneficiary :count.sync="count" :subjectData="subjectData" @confirm="handleValidityBeneficiary"></Beneficiary>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="info" @click="count++">保存草稿</el-button>
        <el-button type="primary" @click="count++">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import License from '../../components/subjectInfo/license';
import Certificate from '../../components/subjectInfo/certificate';
import Institutions from '../../components/subjectInfo/institutions';
import IdCard from '../../components/subjectInfo/idCard';
import Beneficiary from '../../components/subjectInfo/beneficiary';
import IdentityVerify from '../../components/subjectInfo/identityVerify';
import { saveEditDraft, draftEcho, mediaId } from '../../../../api/module/merchants';

export default {
  components: {
    License,
    Certificate,
    Institutions,
    IdentityVerify,
    IdCard,
    Beneficiary,
  },
  props: {},
  data() {
    return {
      type: 0,
      owner: 0,
      count: 0, // 是否开始验证
      LicenseInfo: {
        licenseCopy: '',
        licenseNumber: '',
        businessLicenseInfoMerchantName: '',
        businessLicenseInfoLegalPerson: '',
        idCardName: '',
        type: 0,
      },
      InstitutionsInfo: {
        organizationCopy: [],
        organizationCode: '',
        orgPeriodBegin: '',
        orgPeriodEnd: '',
        type: 0,
      },
      IdentityVerifyInfo: {
        verificationMethod: 0,
        certificateLetterCopy: [],
      },
      IdCardInfo: {
        idDocType: '',
        idCardInfoIdCardCopy: [],
        idCardInfoIdCardNational: [],
        idCardName: '',
        idCardNumber: '',
        cardPeriodBegin: '',
        cardPeriodEnd: '',
        owner: 0,
        type: 0,
      },
      CertificateInfo: {
        certCopy: [],
        certType: '',
        certNumber: '',
        certificateInfoMerchantName: '',
        companyAddress: '',
        certificateInfoLegalPerson: '',
        periodBegin: '',
        periodEnd: '',
        cardType: 0,
        type: 0,
      },
      BeneficiaryInfo: {
        idType: '',
        uboInfoIdCardCopy: [],
        uboInfoIdCardNational: [],
        name: '',
        idNumber: '',
        idPeriodBegin: '',
        idPeriodEnd: '',
        type: 0,
      },
      LicensePass: false, //营业执照
      InstitutionsPass: false, //组织机构代码证
      IdentityVerifyPass: false, //身份验证
      IdCardPass: false, //经营者证件
      CertificatePass: false, //登记证书
      BeneficiaryPass: false, //最终受益人信息
      subjectData: {}, // 回显信息
      licenseCopyMedia: '',
      idCardInfoIdCardCopyMedia: '',
      idCardInfoIdCardNationalMedia: '',
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    typeEdit() {
      return this.$route.query.type;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    if (this.typeEdit == 'edit') {
      this.draftEcho();
    }
  },
  methods: {
    changeType(type) {
      console.log(type);
      this.type = type;
    },
    changeOwner(owner) {
      console.log(owner);
      this.owner = owner;
    },
    handleValidityLicense({ flag, ruleForm }) {
      this.LicenseInfo = { ...ruleForm };
      this.LicensePass = flag;
      this.handleSave();
    },
    handleValidityInstitutions({ flag, ruleForm }) {
      this.InstitutionsInfo = { ...ruleForm };
      this.InstitutionsPass = flag;
      this.handleSave();
    },
    handleValidityIdentityVerify({ flag, ruleForm }) {
      this.IdentityVerifyInfo = { ...ruleForm };
      this.IdentityVerifyPass = flag;
      this.handleSave();
    },
    handleValidityIdCard({ flag, ruleForm }) {
      this.IdCardInfo = { ...ruleForm };
      this.IdCardPass = flag;
      this.handleSave();
    },
    handleValidityCertificate({ flag, ruleForm }) {
      this.CertificateInfo = { ...ruleForm };
      this.CertificatePass = flag;
      this.handleSave();
    },
    handleValidityBeneficiary({ flag, ruleForm }) {
      this.BeneficiaryInfo = { ...ruleForm };
      this.BeneficiaryPass = flag;
      this.handleSave();
    },
    handleSave() {
      const {
        LicensePass,
        IdCardPass,
        BeneficiaryPass,
        InstitutionsPass,
        CertificatePass,
        IdentityVerifyPass,
        id,
        owner,
        type,
      } = this;

      if (id == 0 && owner == 0) {
        if (LicensePass && IdCardPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 0 && owner == 1) {
        if (LicensePass && IdCardPass && BeneficiaryPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 1 && type == 0 && owner == 0) {
        if (LicensePass && IdCardPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 1 && type == 1 && owner == 0) {
        if (LicensePass && IdCardPass && InstitutionsPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 1 && type == 1 && owner == 1) {
        if (LicensePass && IdCardPass && InstitutionsPass && BeneficiaryPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 1 && type == 0 && owner == 1) {
        if (LicensePass && IdCardPass && BeneficiaryPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 2 && type == 0) {
        if (CertificatePass && IdentityVerifyPass && IdCardPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 2 && type == 1) {
        if (CertificatePass && IdentityVerifyPass && IdCardPass && InstitutionsPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 3 && type == 0 && owner == 0) {
        if (CertificatePass && IdCardPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 3 && type == 1 && owner == 0) {
        if (CertificatePass && IdCardPass && InstitutionsPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 3 && type == 1 && owner == 1) {
        if (CertificatePass && IdCardPass && InstitutionsPass && BeneficiaryPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      } else if (id == 3 && type == 0 && owner == 1) {
        if (CertificatePass && IdCardPass && BeneficiaryPass) {
          const obj = this.formatSubmitData();
          console.log('处理后的数据===', obj);
          this.saveEditDraft(obj);
        }
      }
    },
    formatSubmitData() {
      let obj = {};
      // const { id } = this.$route.query;
      const {
        LicenseInfo,
        InstitutionsInfo,
        IdentityVerifyInfo,
        IdCardInfo,
        CertificateInfo,
        BeneficiaryInfo,
        uuid,
        merchantId,
        licenseCopyMedia,
        idCardInfoIdCardCopyMedia,
        idCardInfoIdCardNationalMedia,
        id,
      } = this;
      console.log('LicenseInfo', LicenseInfo);
      obj = {
        subjectDataVO: {
          businessCode: '',
          businessLicenseInfoLegalPerson:
            id == 0 ? LicenseInfo.businessLicenseInfoLegalPerson : LicenseInfo.certificateInfoLegalPerson,
          businessLicenseInfoMerchantName: LicenseInfo.businessLicenseInfoMerchantName,
          cardPeriodBegin: IdCardInfo.cardPeriodBegin,
          cardPeriodEnd: IdCardInfo.cardPeriodEnd,
          certCopy: CertificateInfo.certCopy.length ? CertificateInfo.certCopy : '',
          certNumber: CertificateInfo.certNumber,
          certType: CertificateInfo.certType,
          certificateInfoLegalPerson: CertificateInfo.certificateInfoLegalPerson,
          certificateInfoMerchantName: CertificateInfo.certificateInfoMerchantName,
          verificationMethod: IdentityVerifyInfo.verificationMethod,
          certificateLetterCopy: IdentityVerifyInfo.certificateLetterCopy.length
            ? IdentityVerifyInfo.certificateLetterCopy
            : '',
          companyAddress: CertificateInfo.companyAddress,
          docPeriodBegin: '',
          docPeriodEnd: '',
          idCardInfoIdCardCopy: IdCardInfo.idCardInfoIdCardCopy,
          idCardInfoIdCardCopyMedia,
          idCardInfoIdCardNational: IdCardInfo.idCardInfoIdCardNational.length
            ? IdCardInfo.idCardInfoIdCardNational
            : '',
          idCardInfoIdCardNationalMedia,
          idCardName: IdCardInfo.idCardName,
          idCardNumber: IdCardInfo.idCardNumber,
          idDocInfoIdDocCopy: '',
          idDocName: '',
          idDocNumber: '',
          idDocType: IdCardInfo.idDocType,
          idNumber: BeneficiaryInfo.idNumber,
          idPeriodBegin: BeneficiaryInfo.idPeriodBegin,
          idPeriodEnd: BeneficiaryInfo.idPeriodEnd,
          idType: BeneficiaryInfo.idType,
          licenseCopy: LicenseInfo.licenseCopy.length ? LicenseInfo.licenseCopy : '',
          licenseNumber: LicenseInfo.licenseNumber,
          licenseCopyMedia,
          name: BeneficiaryInfo.name,
          orgPeriodBegin: InstitutionsInfo.orgPeriodBegin,
          orgPeriodEnd: InstitutionsInfo.orgPeriodEnd,
          organizationCode: InstitutionsInfo.organizationCode,
          organizationCopy: InstitutionsInfo.organizationCopy.length ? InstitutionsInfo.organizationCopy : '',
          owner: IdCardInfo.owner == 0 ? 'true' : 'false',
          periodBegin: CertificateInfo.periodBegin,
          periodEnd: CertificateInfo.periodEnd,
          subjectType: this.subjectName,
          uboInfoIdCardCopy: BeneficiaryInfo.uboInfoIdCardCopy.length ? BeneficiaryInfo.uboInfoIdCardCopy : '',
          uboInfoIdCardNational: BeneficiaryInfo.uboInfoIdCardNational.length
            ? BeneficiaryInfo.uboInfoIdCardNational
            : '',
          uboInfoIdDocCopy: '',
        },
        uuid,
        merchantId,
        type: 'subject',
        listVO: {
          status: 0,
          subjectType: this.subjectName,
          merchantType: this.facilitatorName,
        },
      };
      return obj;
    },
    async saveEditDraft(obj) {
      console.log(obj);
      try {
        const result = await saveEditDraft({ ...obj });
        console.log('保存结果', result);
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
              query: {
                id: this.id,
                subjectName: this.subjectName,
                facilitatorName: this.facilitatorName,
                type: 'edit',
                uuid: result,
                merchantId: this.merchantId,
              },
            });
          },
        });
      } catch (err) {
        this.$message({
          message: '保存失败',
          type: 'warring',
          duration: 1500,
        });
      }
    },
    back() {
      this.$router.replace({
        path: '/merchants/addMerchants',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.typeEdit,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    handleMediaId(url, fileName) {
      this.mediaId(url, fileName);
    },
    handleMediaIdCard1(url, fileName) {
      this.mediaId1(url, fileName);
    },
    handleMediaIdCard2(url, fileName) {
      this.mediaId2(url, fileName);
    },
    async mediaId(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.licenseCopyMedia = result.mediaId;
      console.log('licenseCopyMedia', result.mediaId);
    },
    async mediaId1(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.idCardInfoIdCardCopyMedia = result.mediaId;
    },
    async mediaId2(url, fileName) {
      const { merchantId } = this;
      const result = await mediaId({
        baseUrl: url,
        fileName,
        merchantId,
      });
      this.idCardInfoIdCardNationalMedia = result.mediaId;
    },
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.subjectData = result;
      console.log('首页列表数据', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  padding-top: 20px;
  .style {
    margin-bottom: 9px;
  }
  .btn {
    box-sizing: border-box;
    padding-left: 31px;
    margin-top: 57px;
    padding-bottom: 100px;
  }
}
</style>
